<template>
    <div class="reviewDetail-infoShare shareNoteBtn" v-bind:class="{active: isActive}">
        <div class="reviewDetail-infoShareC shareImgBig js-infoShareBtn" @click="share" v-if="status === 15">
            <img src="../../assets/shareIcon.png" class="">
            <span>立即分享</span>
        </div>
        <div class="reviewDetail-infoShareSmall shareImgSmall js-infoShareBtn" @click="share" v-if="status === 15">
            <img src="../../assets/shareIcon.png" class="">
        </div>
        <div class="reviewDetail-infoCamera" v-if="isShowCamera">
            <router-link to="/Rccl.Review/ReviewPicture/UploadPicture" class="external">
                <img src="../../assets/cameraIcon.png" class="">
            </router-link>
        </div>
        <div class="reviewDetail-scrollToTop js-scrollTopBtn" @click="goTop">
            <img src="../../assets/scrollTop.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Share',
        props: {
            isActive: {
                type: Boolean,
                default: false
            },
            status: {
                type: Number,
                default: 0
            },
            isShowCamera: {
                type: Boolean,
                default: true
            },
            shareUrl: {
                type: String,
                default: ""
            },
            shareText: {
                type: String,
                default: ""
            },
            shareImage: {
                type: String,
                default: ""
            }
        },
        methods: {
            share () {
                if (/MicroMessenger/i.test(navigator.userAgent)) {
                    this.$shareTip.show()
                } else {
                    window.open(`http://service.weibo.com/share/share.php?url=${this.shareUrl}&title=${encodeURIComponent(this.shareText)}&pic=${this.shareImage}&searchPic=false`, '_blank', 'width=600, height=550')
                }
            },
            goTop () {
                this.$emit('on-goTop')
            }
        }
    }
</script>

<style lang="less" scoped>
    /**** share、scrollTop ****/
    .reviewDetail-infoShare {
        position: fixed;
        right: 0;
        bottom: 59%;
        height: 80px;
        z-index: 10;
        .reviewDetail-infoShareC {
            background-color: #0073a1;
            border-top-left-radius:20px;
            border-bottom-left-radius:20px;
            width:66px;
            text-align:right;
            height:33px;
            padding-right:5px;
            & > img {
                width:16px;
                height:20px;
                margin-right:2px;
            }
            & > span {
                display: inline-block;
                width: 24px;
                font-size: 12px;
                color: #fff;
                transform: scale(.75);
                -webkit-transform: scale(.75);
                -moz-transform: scale(.75);
                -o-transform: scale(.75);
                vertical-align:sub;
            }
        }
    }
    .reviewDetail-infoShareSmall {
        width: 28px;
        text-align: center;
        height: 28px;
        background-color: #0c77a5;
        border-radius: 14px;
        margin-left: 27px;
        display:none;
        img {
            width: 16px;
            height: 20px;
            vertical-align: middle;
        }
    }
    .reviewDetail-infoCamera {
        width: 28px;
        text-align: center;
        height: 28px;
        background-color: #0c77a5;
        border-radius: 14px;
        margin-top:6px;
        margin-left:27px;
        display:none;
        img{
            width: 20px;
            height: 16px;
            vertical-align: middle;
        }
        &>a{
            display:block;
            width:100%;
            height:100%;
        }
    }
    .reviewDetail-scrollToTop {
        position: relative;
        width: 32px;
        margin-left: 25px;
        margin-top: 7px;
        display: none;
        img {
            width: 100%;
        }
    }
    .reviewDetail-infoShare.active .reviewDetail-scrollToTop,
    .reviewDetail-infoShare.active .reviewDetail-infoShareSmall,
    .reviewDetail-infoShare.active .reviewDetail-infoCamera {
        display: block;
    }
    .reviewDetail-infoShare.active .reviewDetail-infoShareC {
        display: none;
    }
</style>
